import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAchievement = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "0 0 44 44",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [/* @__PURE__ */ _jsxs("g", {
			filter: `url(#${__svgrId}-filter0_ii_2796_1925)`,
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 44,
				height: 44,
				rx: 12,
				fill: "#FFE29A"
			}), /* @__PURE__ */ _jsxs("g", {
				filter: `url(#${__svgrId}-filter1_d_2796_1925)`,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M24.6348 9.81572L26.5016 16.1726C26.5413 16.3326 26.6223 16.4794 26.7365 16.5984C26.8507 16.7173 26.9941 16.8043 27.1525 16.8507L33.3821 18.9256C33.5631 18.982 33.7243 19.0888 33.8469 19.2334C33.9695 19.3779 34.0484 19.5544 34.0745 19.7421C34.1005 19.9298 34.0725 20.121 33.9938 20.2934C33.9152 20.4658 33.789 20.6123 33.6302 20.7157L28.2135 24.4738C28.0764 24.5629 27.9639 24.6849 27.886 24.8286C27.8082 24.9723 27.7675 25.1331 27.7678 25.2966L27.7459 31.9213C27.7455 32.1117 27.6916 32.2981 27.5904 32.4594C27.4892 32.6207 27.3448 32.7504 27.1735 32.8337C27.0021 32.9169 26.8109 32.9505 26.6214 32.9305C26.4319 32.9105 26.2519 32.8377 26.1017 32.7205L20.8792 28.6637C20.7445 28.5654 20.589 28.4992 20.4247 28.4702C20.2605 28.4412 20.0918 28.4503 19.9315 28.4966L13.6365 30.5225C13.4553 30.5813 13.2612 30.5881 13.0763 30.5421C12.8914 30.4961 12.7232 30.3992 12.5906 30.2623C12.4581 30.1255 12.3667 29.9542 12.3268 29.768C12.2869 29.5819 12.3 29.3882 12.3648 29.2092L14.6229 22.9036C14.679 22.7502 14.6958 22.5851 14.6718 22.4234C14.6478 22.2618 14.5837 22.1087 14.4854 21.9781L10.6132 16.6572C10.4983 16.5019 10.4309 16.3166 10.4192 16.1239C10.4074 15.9311 10.4519 15.7391 10.5471 15.571C10.6424 15.403 10.7843 15.2662 10.9558 15.1772C11.1273 15.0882 11.3209 15.0508 11.5133 15.0695L18.0769 15.2504C18.2415 15.261 18.406 15.2283 18.554 15.1556C18.702 15.0828 18.8283 14.9726 18.9204 14.8358L22.8488 9.50081C22.9578 9.34446 23.1092 9.22253 23.2852 9.1494C23.4613 9.07628 23.6546 9.05502 23.8423 9.08812C24.0301 9.12123 24.2045 9.20733 24.3449 9.33625C24.4853 9.46517 24.5859 9.63154 24.6348 9.81572Z",
					stroke: "white",
					strokeWidth: 5.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M24.6348 9.81572L26.5016 16.1726C26.5413 16.3326 26.6223 16.4794 26.7365 16.5984C26.8507 16.7173 26.9941 16.8043 27.1525 16.8507L33.3821 18.9256C33.5631 18.982 33.7243 19.0888 33.8469 19.2334C33.9695 19.3779 34.0484 19.5544 34.0745 19.7421C34.1005 19.9298 34.0725 20.121 33.9938 20.2934C33.9152 20.4658 33.789 20.6123 33.6302 20.7157L28.2135 24.4738C28.0764 24.5629 27.9639 24.6849 27.886 24.8286C27.8082 24.9723 27.7675 25.1331 27.7678 25.2966L27.7459 31.9213C27.7455 32.1117 27.6916 32.2981 27.5904 32.4594C27.4892 32.6207 27.3448 32.7504 27.1735 32.8337C27.0021 32.9169 26.8109 32.9505 26.6214 32.9305C26.4319 32.9105 26.2519 32.8377 26.1017 32.7205L20.8792 28.6637C20.7445 28.5654 20.589 28.4992 20.4247 28.4702C20.2605 28.4412 20.0918 28.4503 19.9315 28.4966L13.6365 30.5225C13.4553 30.5813 13.2612 30.5881 13.0763 30.5421C12.8914 30.4961 12.7232 30.3992 12.5906 30.2623C12.4581 30.1255 12.3667 29.9542 12.3268 29.768C12.2869 29.5819 12.3 29.3882 12.3648 29.2092L14.6229 22.9036C14.679 22.7502 14.6958 22.5851 14.6718 22.4234C14.6478 22.2618 14.5837 22.1087 14.4854 21.9781L10.6132 16.6572C10.4983 16.5019 10.4309 16.3166 10.4192 16.1239C10.4074 15.9311 10.4519 15.7391 10.5471 15.571C10.6424 15.403 10.7843 15.2662 10.9558 15.1772C11.1273 15.0882 11.3209 15.0508 11.5133 15.0695L18.0769 15.2504C18.2415 15.261 18.406 15.2283 18.554 15.1556C18.702 15.0828 18.8283 14.9726 18.9204 14.8358L22.8488 9.50081C22.9578 9.34446 23.1092 9.22253 23.2852 9.1494C23.4613 9.07628 23.6546 9.05502 23.8423 9.08812C24.0301 9.12123 24.2045 9.20733 24.3449 9.33625C24.4853 9.46517 24.5859 9.63154 24.6348 9.81572Z",
					fill: "#FFE29A",
					stroke: "#B87C1F",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})]
			})]
		}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: `${__svgrId}-filter0_ii_2796_1925`,
			x: 0,
			y: 0,
			width: 44,
			height: 44,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 1,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect1_innerShadow_2796_1925"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "shape",
					result: "effect1_innerShadow_2796_1925"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: -1 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "arithmetic",
					k2: -1,
					k3: 1
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_innerShadow_2796_1925",
					result: "effect2_innerShadow_2796_1925"
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: `${__svgrId}-filter1_d_2796_1925`,
			x: 6.66699,
			y: 6.32227,
			width: 31.167,
			height: 32.3633,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.721569 0 0 0 0 0.486275 0 0 0 0 0.121569 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_2796_1925"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_2796_1925",
					result: "shape"
				})
			]
		})] })]
	});
};
export default SvgIconAchievement;
